var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _circle, _circle2, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIphoneFrame = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 350 678",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 26,
  y: 150,
  fill: "#AEB4C2",
  rx: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 46,
  y: 198,
  fill: "#AEB4C2",
  rx: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 46,
  y: 256,
  fill: "#AEB4C2",
  rx: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 72,
  x: 347,
  y: 214,
  fill: "#AEB4C2",
  rx: 1.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 345,
  height: 673,
  x: 2.5,
  y: 2.5,
  stroke: "#AEB4C2",
  strokeWidth: 1.5,
  rx: 55
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 332,
  height: 660,
  x: 9,
  y: 9,
  stroke: "#0B0B12",
  strokeWidth: 14,
  rx: 47
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0B0B12",
  d: "M116 16h118v13c0 7.18-5.82 13-13 13h-92c-7.18 0-13-5.82-13-13z"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 5,
  x: 158,
  y: 26,
  fill: "#23252E",
  rx: 2.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 206,
  cy: 29,
  r: 4,
  fill: "#1B2A40"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 206,
  cy: 29,
  r: 1.6,
  fill: "#314B6E"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 5,
  x: 121,
  y: 648,
  fill: "#0B0B12",
  rx: 2.5
})));
export default SvgIphoneFrame;